export default "/images/vendor/flag-icon-css/flags/1x1/dm.svg?f17f9b312e559bd63608852316431fbf";